const React = require('react');
const T = require('prop-types');
const { ThemeProvider } = require('styled-components');
const { StyledEngineProvider, ThemeProvider: MuiThemeProvider } = require('@mui/material/styles');
const { context } = require('app-context');
const { useAppSelector } = require('utils/redux');

const {
    selectors: {
        all: selectors
    }
} = context;

const ThemeManager = function ThemeManager(props) {

    const {
        theme,
        children
    } = props;

    const currentSchool = useAppSelector(selectors.getCurrentSchool);
    const isLoggedInPath = location.pathname.startsWith('/app/');

    const themeWithSchoolOverrides = (isLoggedInPath && currentSchool?.theme)
        ? theme(currentSchool.theme)
        : theme();

    return (
        <ThemeProvider theme={themeWithSchoolOverrides}>
            <StyledEngineProvider>
                <MuiThemeProvider theme={themeWithSchoolOverrides}>
                    {children}
                </MuiThemeProvider>
            </StyledEngineProvider>
        </ThemeProvider>
    );
};

ThemeManager.propTypes = {
    theme: T.object.isRequired,
    children: T.any
};

module.exports = ThemeManager;
